package floris.graphics.extensions

fun String.isValidUrl(): Boolean {
    val urlRegex = Regex("^https?://[\\w.-]+(?:\\.[\\w.-]+)+[/#?]?.*$")
    return this.matches(urlRegex)
}

fun String.isYoutubeOrVimeoUrl(): Boolean {
    val videoUrlRegex = Regex(
        """^(https?://)?(www\.)?(youtube\.com/watch\?v=[\w-]{11}|youtu\.be/[\w-]{11}|vimeo\.com/\d+)(\S*)?$""",
        RegexOption.IGNORE_CASE
    )
    return videoUrlRegex.matches(this)
}
